import api from './api';

export const stockEntryService = {
  // Récupérer toutes les entrées de stock
  async getStockEntries(params = {}) {
    try {
      const response = await api.get('/stock-entries', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des entrées:', error);
      throw error;
    }
  },

  // Récupérer une entrée par ID
  async getStockEntryById(id) {
    try {
      const response = await api.get(`/stock-entries/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'entrée:', error);
      throw error;
    }
  },

  // Créer une nouvelle entrée de stock
  async createStockEntry(data) {
    try {
      const response = await api.post('/stock-entries', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de l\'entrée:', error);
      throw error;
    }
  },

  // Mettre à jour une entrée de stock
  async updateStockEntry(id, data) {
    try {
      const response = await api.put(`/stock-entries/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'entrée:', error);
      throw error;
    }
  },

  // Supprimer une entrée de stock
  async deleteStockEntry(id) {
    try {
      const response = await api.delete(`/stock-entries/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'entrée:', error);
      throw error;
    }
  },

  // Récupérer les statistiques des entrées
  async getStockEntryStats() {
    try {
      const response = await api.get('/stock-entries/stats');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques:', error);
      throw error;
    }
  },

  // Récupérer les entrées par produit
  async getStockEntriesByProduct(productId, params = {}) {
    try {
      const response = await api.get(`/stock-entries/product/${productId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des entrées par produit:', error);
      throw error;
    }
  },

  // Récupérer les entrées par fournisseur
  async getStockEntriesBySupplier(supplierId, params = {}) {
    try {
      const response = await api.get(`/stock-entries/supplier/${supplierId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des entrées par fournisseur:', error);
      throw error;
    }
  }
}; 